export const LABEL_COLOUR_MAP = {
  "Real Time": "#194d33",
  "Real Device": "#009ce0",
  "Web Automation": "#000000",
  "App Automation": "#4d4d4d",
  KaneAI: "#E666FF",
  MCP: "#876b6bd6",
  SmartUI: "#f44e3b",
  HyperExecute: "#E6B333",
  Insights: "#33FFCC",
  "Test Manager": "#B33300",
  Accessibility: "#CC80CC",
  Integrations: "#73d8ff",
  "TestMu AI Tunnel": "#68bc00",
  "LT Browser": "#fa28ff",
  Certifications: "#CCCC00",
  "Test At Scale": "#4D80CC",
  "Live App": "#808900",
  Releases: "#ff4772",
  Fixes: "#33FFCC",
  Enhancements: "#37d67a",
  Features: "#3778ff",
  Announcements: "#3778ff",
  "Agent to Agent Testing": "#FF6B35",
};

export const ALL_POSTS_LABEL = "All Posts";
